module.exports = __webpack_public_path__ + "img/service-04.ca3d363c.svg";